import { connect } from 'react-redux'
import Sidebar from './../../../../common/containers/Sidebar'
import Card from './../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import CheckList from './CheckList'
import { useState } from 'react'
import CheckDetail from './CheckDetail'

let CheckPage = () => {
    const [pageAttr, setPageAttr] = useState({})

    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/detail/:checkId' element={<CheckDetail setPageAttr={setPageAttr} />} />
                    <Route path='/' element={<CheckList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(CheckPage)